import { API_CLIENT } from "../api_call/service_instances.js";

import {
  MARKERS_MAP_DATA_CCTV,
  ROUTES_DATA_MAP_TRAFFIC,
  GET_STREET
} from "../url/urls_in_app.js";

/*
 * --------------------------------------------------------
 *  Contain all url and fuctions needed to make call to the application
 *  only for trafic part
 * --------------------------------------------------------
 */

export default {
  getRoutesData() {
    return API_CLIENT(ROUTES_DATA_MAP_TRAFFIC);
  },

  getMarkers() {
    return API_CLIENT(MARKERS_MAP_DATA_CCTV);
  },
  getStreets() {
    return API_CLIENT(GET_STREET);
  }
};
